import { Routes } from '@angular/router';

import { ecuCoverageUnsavedChangesGuard } from 'src/app/guards/ecu-coverage-unsaved-changes.guard';
import { databaseDemoRunningGuard } from 'src/app/guards/database-demo-running.guard';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () => import('src/app/components/ecu-coverage/ecu-coverage.component').then(m => m.EcuCoverageComponent),
		title: 'ECU Coverage | Chimera',
		canDeactivate: [ecuCoverageUnsavedChangesGuard],
	},

	{
		path: 'vehicle-test-suite',
		loadComponent: () => import('src/app/components/vehicle-test-suite/vehicle-test-suite.component').then(m => m.VehicleTestSuiteComponent),
		title: 'Vehicle Test Suite | Chimera',
	},
	{
		path: 'settings',
		loadComponent: () => import('src/app/components/settings/settings.component').then(m => m.SettingsComponent),
		title: 'Settings | Chimera',
	},
	{
		// Developer tool comparing results from MSSQL and PostgreSQL. Intentionally not linked from the navigation.
		path: 'database-demo',
		loadComponent: () => import('src/app/components/database-demo/database-demo.component').then(m => m.DatabaseDemoComponent),
		title: 'Database Demo | Chimera',
		canDeactivate: [databaseDemoRunningGuard],
	},
];
